import { journalsServiceApi } from "@entities/api";

interface ICreateSectionTwoRecord {
  itemNoVersionId: string;
  updateSectionTwoRequest: {
    mainJournalId: string;
    section2Id: string;
    section2ListId: string;
    specialJournalName: string;
    specialJournalDate: string;
    journalKeepersList?: Array<any>;
    dateHandover?: string | null;
    signer: string;
  };
  file?:
    | { file?: File | null | undefined; id?: string | null | undefined }
    | null
    | undefined;
}

export async function updateSectionTwoRecord({
  itemNoVersionId,
  updateSectionTwoRequest,
  file,
}: ICreateSectionTwoRecord) {
  const formData = new FormData();

  formData.append(
    "updateSectionTwoRequest",
    new Blob(
      [
        JSON.stringify({
          ...updateSectionTwoRequest,
        }),
      ],
      {
        type: "application/json",
      },
    ),
  );

  if (file?.file) {
    formData.append("file", file.file);
    formData.append(
      "fileMetadata",
      new Blob(
        [
          JSON.stringify({
            fileNumber: 1,
            fileName: file.file.name,
            fileType: file.file.type,
            fileContentLength: file.file.size,
          }),
        ],
        {
          type: "application/json",
        },
      ),
    );
  }

  const response = await journalsServiceApi.putForm(
    `/journals/section-two/items/${itemNoVersionId}`,
    formData,
  );

  return response.data;
}
